import { useQuery } from '@tanstack/react-query';

import { plansService } from '@chartai/firebase';
import { type StripeV2Plan } from '@chartai/utils';

import { plansKeys } from '../queryKeys';

interface UseStripePlansResult {
  plans: StripeV2Plan[];
  v1PriceIds: Set<string>;
  isLoading: boolean;
}

export function useStripePlans(): UseStripePlansResult {
  const { data, isLoading } = useQuery({
    queryKey: plansKeys.stripe(),
    queryFn: () => plansService.fetchStripePlans(),
    staleTime: 1000 * 60 * 10,
  });

  return {
    plans: data?.plans ?? [],
    v1PriceIds: new Set(data?.v1PriceIds ?? []),
    isLoading,
  };
}
